module.exports = __webpack_public_path__ + "static/img/Crait_Resource_03.34d5ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180419/Crait_Resource_03.png
// module id = 254
// module chunks = 1